import styled from 'styled-components';
import { TextField } from '@mui/material';
import colors from '../../../styles/colors';
import InputLabel from '../../../components/v2/InputLabel';

const InputContainer = styled.div`
  display: flex;
  padding: 20px 50px;
  gap: 10px;
  align-items: center;
`;

const StyledTextLabel = styled(InputLabel)`
  font-size: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  width: 100%;
`;

const AutocompleteTextField = styled(TextField)`
  box-sizing: content-box;
  width: calc(100% - 6px);
  position: relative;
  margin-left: 6px;

  .MuiInputBase-root {
    height: 40px;
    background-color: ${colors.base.alpha};

    .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.shades.secondary7};
      border-radius: 5px;
    }

    .MuiInputBase-input {
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      color: ${colors.shades.secondary8};
      padding: 0px;
    }

    &.Mui-disabled {
      background-color: ${colors.shades.secondary5};
      .MuiInputBase-input {
        -webkit-text-fill-color: initial;
      }
    }
  }
`;

export {
  InputContainer,
  StyledTextLabel,
  ButtonContainer,
  AutocompleteTextField,
};
